import Axios from 'axios';
import {keycloak} from './keycloak';

export const axios = Axios.create();

axios.interceptors.request.use(config => new Promise((resolve, reject) =>
    keycloak.updateToken(5)
        .then(() => {
            config.headers.Authorization = 'Bearer ' + keycloak.token;
            resolve(config);
        })
        .catch(error => reject(error))
));
